import Cookies from 'js-cookie';

export const ONE_LINK_HOST_SUFFIX = '.onelink.me';

/**
 * Adds avt to all AppsFlyer OneLink URLs which are used to direct users to the correct app store. Passing avt is
 * necessary to accurately track campaign performance and effectively attribute Square app installs.
 *
 * @see https://block.atlassian.net/browse/PWB-1091
 */
const oneLinkHelper = {
  initialize: () => {
    const savt = Cookies.get('_savt');
    if (!savt) {
      return;
    }

    for (const link of document.querySelectorAll('a')) {
      let url: URL;
      try {
        url = new URL(link.href);
      } catch {
        continue;
      }

      if (!url.hostname.endsWith(ONE_LINK_HOST_SUFFIX)) {
        continue;
      }

      if (!url.searchParams.get('_avt')) {
        url.searchParams.set('_avt', savt);
      }

      link.href = url.toString();
    }
  },
};

export default oneLinkHelper;
